var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section-banner',{attrs:{"data":_vm.bannerTotalData,"imgList":_vm.bannerImgs}}),_vm._v(" "),_c('solution-new'),_vm._v(" "),_c('service-advantage'),_vm._v(" "),_c('industry-news',{attrs:{"data":_vm.industryList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }